import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  ChangeDetectorRef,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { NgForm } from "@angular/forms";
import { fromEvent, Subject } from "rxjs";
import { debounceTime, distinctUntilChanged, takeUntil } from "rxjs/operators";
import { HelperService } from "@services/helper.service";

@Component({
  selector: "app-search-autocomplete",
  templateUrl: "./search-autocomplete.component.html",
  styleUrls: ["./search-autocomplete.component.scss"],
})
export class SearchAutocompleteComponent
  implements OnInit, OnDestroy, OnChanges
{
  @ViewChild("formSearchAutocomplete") formSearchAutocomplete: NgForm;
  @ViewChild("inputSearchAutocomplete") inputSearchAutocomplete: ElementRef;
  @Output() onSearch: EventEmitter<string> = new EventEmitter<string>();
  @Output() handleFocus: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() minLength = 0;
  @Input() label: string = "";
  @Input() searchOnKeypress: boolean = false;
  @Input() required: boolean = true;

  @Input() authorization: boolean = false;
  @Input() sinisterNumber: boolean = false;

  public searchStringAutocomplete: string;

  private readonly unsubscribe$: Subject<void> = new Subject<void>();

  constructor(private cdRef: ChangeDetectorRef, public helper: HelperService) {}

  ngOnInit() {
    const searchText$ = fromEvent(
      this.inputSearchAutocomplete.nativeElement,
      "keyup"
    );
    if (this.searchOnKeypress) {
      searchText$
        .pipe(
          debounceTime(2000),
          takeUntil(this.unsubscribe$),
          distinctUntilChanged()
        )
        .subscribe(() => this.search(this.searchStringAutocomplete));
    }
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  ngOnChanges(changes: SimpleChanges): void {}

  search(searchString: string) {
    if (searchString && searchString.length > this.minLength) {
      const trimValue = this.helper.trimValue(searchString);
      this.onSearch.emit(trimValue);
    } else {
      this.onSearch.emit("");
    }
  }

  reset() {
    this.searchStringAutocomplete = "";
    this.formSearchAutocomplete.reset();
  }

  focusElement() {
    this.inputSearchAutocomplete.nativeElement.focus();
  }

  focus() {
    this.handleFocus.emit(true);
  }

  focusOut() {
    this.handleFocus.emit(false);
    if (!this.searchStringAutocomplete) {
      this.markAspristine();
    }
  }

  markAspristine() {
    this.formSearchAutocomplete.form.markAsPristine();
    this.formSearchAutocomplete.form.markAsUntouched();
  }

  markAsDirty() {
    this.formSearchAutocomplete.form.markAsDirty();
    this.formSearchAutocomplete.form.markAsTouched();
    this.focusElement();
  }

  clearFocus() {
    this.inputSearchAutocomplete.nativeElement.blur();
  }
}
